export function setTipoMovilidadCaract(departamento, municipio) {
    if (departamento !== '5') {
        return '2';
    }else if (departamento === '5') {
        if (municipio !== '1') {
            return '3';
        } else if (municipio === '1') {
            return '1';
        }
    }
}